export default {
  name: 'ZoneColorDialogComponent',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedZones: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    selectedColor: null,
    hexColor: '',
    hexError: '',
    opacity: 1,
    selectedBorderColor: null,
    borderColor: '#000000',
    borderColorError: '',
    borderWidth: 1
  }),
  watch: {
    show: {
      handler(newValue) {
        if (newValue) {
          // Resetear el estado cuando se abre el diálogo
          this.resetState()
        }
      },
      immediate: true
    },
    selectedColor: {
      handler(newColor) {
        if (newColor && typeof newColor === 'object' && newColor.hex) {
          this.hexColor = newColor.hex
        } else if (typeof newColor === 'string') {
          this.hexColor = newColor
        }
      },
      immediate: true
    },
    selectedBorderColor: {
      handler(newColor) {
        if (newColor && typeof newColor === 'object' && newColor.hex) {
          this.borderColor = newColor.hex
        } else if (typeof newColor === 'string') {
          this.borderColor = newColor
        }
      },
      immediate: true
    }
  },
  methods: {
    resetState() {
      this.selectedColor = null
      this.hexColor = ''
      this.hexError = ''
      this.opacity = 1
      this.selectedBorderColor = null
      this.borderColor = '#000000'
      this.borderColorError = ''
      this.borderWidth = 1
    },
    cancel() {
      this.$emit('cancel')
    },
    onHexInput(value) {
      this.hexColor = value
      this.hexError = ''
    },
    validateHexColor() {
      if (this.hexColor && !this.isValidHexColor(this.hexColor)) {
        this.hexError = this.$t('color.invalidHexCode')
      } else {
        this.hexError = ''
      }
    },
    isValidHexColor(hex) {
      return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3}|[A-Fa-f0-9]{8})$/.test(hex)
    },
    onColorPickerChange(color) {
      if (color && typeof color === 'object' && color.hex) {
        this.selectedColor = color.hex
        this.hexColor = color.hex
      } else if (typeof color === 'string') {
        this.selectedColor = color
        this.hexColor = color
      }
      this.hexError = ''
    },
    onBorderColorInput(value) {
      this.borderColor = value
      this.borderColorError = ''
    },
    onBorderColorPickerChange(color) {
      if (color && typeof color === 'object' && color.hex) {
        this.selectedBorderColor = color.hex
        this.borderColor = color.hex
      } else if (typeof color === 'string') {
        this.selectedBorderColor = color
        this.borderColor = color
      }
      this.borderColorError = ''
    },
    validateBorderColor() {
      if (this.borderColor && !this.isValidHexColor(this.borderColor)) {
        this.borderColorError = this.$t('color.invalidHexCode')
      } else {
        this.borderColorError = ''
      }
    },
    onBorderWidthChange(value) {
      this.borderWidth = value
    },
    onOpacityChange(value) {
      this.opacity = value
    },
    getColorWithOpacity() {
      const hexValue = this.getHexValue()
      
      if (!hexValue) {
        return '#FF0000FF'
      }
      
      // Si ya tiene 8 dígitos (incluye opacidad), extraer solo los primeros 6
      const baseColor = hexValue.length === 8 ? hexValue.substring(0, 7) : hexValue
      
      // Convertir opacidad a hexadecimal (0-1 a 00-FF)
      const alphaHex = Math.round(this.opacity * 255).toString(16).padStart(2, '0')
      
      const result = baseColor + alphaHex
      return result
    },
    save() {
      const colorWithOpacity = this.getColorWithOpacity()
      const finalColor = colorWithOpacity || '#FF0000FF'
      
      
      this.$emit('colorSelected', {
        zones: this.selectedZones,
        color: finalColor,
        borderColor: this.borderColor,
        borderWidth: this.borderWidth
      })
      
      
      this.resetState()
    },
    getHexValue() {
      if (this.selectedColor && typeof this.selectedColor === 'object' && this.selectedColor.hex) {
        return this.selectedColor.hex
      } else if (typeof this.selectedColor === 'string') {
        return this.selectedColor
      } else if (this.hexColor) {
        return this.hexColor
      }
      return null
    }
  }
} 